<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-cog title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.csvHistory' | transloco}}</p>
        <p>{{'menu.descriptions.csvHistory' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-end">
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(first)]="first"
          [(rows)]="rows"
          [value]="history"
          [totalRecords]="totalFiles"
          [sortOrder]="-1"
          [autoLayout]="true"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          breakpoint="1600px"
          sortField="uploadedDate"
          responsiveLayout="stack"
          dataKey="uuid"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="w-3rem"></th>
              <th pSortableColumn="fileName">
                {{'attribute.fileName' | transloco}}
                <p-sortIcon field="fileName"></p-sortIcon>
              </th>
              <th pSortableColumn="type">
                {{'attribute.csvType' | transloco}}
                <p-sortIcon field="type"></p-sortIcon>
              </th>
              <th pSortableColumn="status">
                {{'attribute.csvStatus' | transloco}}
                <p-sortIcon field="status"></p-sortIcon>
              </th>
              <th pSortableColumn="tenant.name" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'model.tenant' | transloco}}
                <p-sortIcon field="tenant.name"></p-sortIcon>
              </th>
              <th pSortableColumn="organization.name" *ngIf="'ROLE_ADMIN' | userHasRole: false">
                {{'model.organization' | transloco}}
                <p-sortIcon field="organization.name"></p-sortIcon>
              </th>
              <th pSortableColumn="uploadedDate">
                {{'attribute.uploadedDate' | transloco}}
                <p-sortIcon field="uploadedDate"></p-sortIcon>
              </th>
              <th class="w-10rem">
                {{'common.actions' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-history let-expanded="expanded">
            <tr *ngIf="!loadingHistory">
              <td *ngIf="history.error">
                <span class="p-column-title bold">{{'common.expand' | transloco}}</span>
                <button
                  [pRowToggler]="history"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  pButton
                  pRipple
                  class="p-button-text p-button-rounded p-button-plain"
                  type="button"
                ></button>
              </td>
              <td *ngIf="!history.error">

              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}</span>
                <p class="text-right md:text-left">{{history.fileName}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.creationAt' | transloco}}</span>
                <p class="text-right md:text-left">{{'model.' + history.type.toLowerCase() | transloco}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                <p-tag *ngIf="history.status == 'PROCESSED'" severity="success">{{'info.importCsv.status.processed' | transloco | uppercase}}</p-tag>
                <p-tag *ngIf="history.status == 'PROCESSING'" severity="info">{{'info.importCsv.status.processing' | transloco | uppercase}}</p-tag>
                <p-tag *ngIf="history.status == 'ERROR'" severity="danger">{{'info.importCsv.status.error' | transloco | uppercase}}</p-tag>
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
                <a *ngIf="history.tenant" [routerLink]="['/management/tenants', history.tenant.uuid, 'details']">
                  {{history.tenant.name}}
                </a>
              </td>
              <td *ngIf="'ROLE_ADMIN' | userHasRole: false">
                <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                <a *ngIf="history.organization" [routerLink]="['/management/organizations', history.organization.uuid, 'details']">
                  {{history.organization.name}}
                </a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.dateLastValueReported' | transloco}}</span>
                <p class="text-right md:text-left">{{history.uploadedDate | customDate}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-start">
                  <button
                    (click)="downloadFile(history)"
                    class="p-button-rounded btn-primary-light mr-2"
                    pButton
                    pRipple
                    icon="pi pi-download"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingHistory">
              <td class="row-height" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height" *ngIf="'ROLE_ADMIN' | userHasRole: false">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="rowexpansion" let-history>
            <tr>
              <td colspan="8">
                <div class="grid">
                  <div class="col-12">
                    <b>Error:</b>
                  </div>
                  <div class="col-12">
                    <p>{{history.error | transloco}}</p>
                  </div>

                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalFiles == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalFiles > 0">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalFiles ? totalFiles : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalFiles}}
              {{(totalFiles > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <div>
    <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="serialNumber">{{'attribute.fileName' | transloco}}</label>
        </div>
        <div class="col-12">
          <input
            [(ngModel)]="currentFilters.fileName"
            [focus]="filtersVisible"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            appAutoFocus
            pInputText
            class="w-full"
            id="serialNumber"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="type">{{'attribute.csvType' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.types"
            [placeholder]="'select.generic' | transloco"
            [options]="types"
            [filter]="true"
            [styleClass]="'w-full'"
            id="type"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="status">{{'attribute.csvStatus' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.status"
            [placeholder]="'select.generic' | transloco"
            [options]="status"
            [filter]="true"
            [styleClass]="'w-full'"
            id="status"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>

      <div class="col-12" *ngIf="authGuardService.superAdminRequired()">
        <div class="col-12 form-field">
          <label for="tenant">{{'model.tenant' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.tenantUuids"
            [placeholder]="'select.generic' | transloco"
            [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body"
            [options]="tenants"
            (onChange)="this.currentFilters.organizationUuids = []"
            id="tenant"
            optionLabel="name"
            optionValue="uuid"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12" *ngIf="userData && userData.organization == null">
        <div class="col-12 form-field">
          <label for="organization">{{'model.organization' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.organizationUuids"
            [placeholder]="'select.generic' | transloco"
            [options]="filteredOrganizations"
            [filter]="true"
            styleClass="w-full"
            id="organization"
            optionLabel="name"
            optionValue="uuid"
            filterBy="name"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="dateRanges">{{'attribute.uploadedDate' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-calendar
            [(ngModel)]="dateRanges"
            [firstDayOfWeek]="1"
            [readonlyInput]="false"
            styleClass="w-full"
            id="dateRanges"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            appendTo="body"
            inputId="range"
          ></p-calendar>
        </div>
      </div>
      <div class="col-12">
        <p-button
          [label]="'common.filter' | transloco"
          [disabled]="!(
            currentFilters.fileName ||
            currentFilters.status ||
            currentFilters.types ||
            currentFilters.tenantUuids ||
            currentFilters.organizationUuids ||
            dateRanges
          )"
          (onClick)="filtersVisible = false; applyFilters()"
          styleClass="p-button-primary mx-2 mt-2"
          type="button"
        ></p-button>
        <p-button
          [label]="'common.clear' | transloco"
          (click)="resetFilters(); filtersVisible = false;"
          styleClass="p-button-danger"
          type="button"
        ></p-button>
      </div>
    </div>
  </div>
</p-sidebar>
